import { render, staticRenderFns } from "./SupplierAddress.vue?vue&type=template&id=ca5ee35a&"
import script from "./SupplierAddress.vue?vue&type=script&lang=js&"
export * from "./SupplierAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports